export const getNativeUserIdFromCookies = () => {
  return document?.cookie
    .split("; ")
    .find((row) => row.startsWith("NATIVE_USERID"))
    ?.split("=")[1];
};
